class TextImageCollageSlider extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.track = this.querySelector('[data-collage-track]');
    this.indicators = Array.from(this.querySelectorAll('[data-collage-indicator]'));
    this.mobileMedia = window.matchMedia('(max-width: 749px)');

    if (!this.track || !this.indicators.length) return;

    this.onIndicatorClick = this.onIndicatorClick.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onBreakpointChange = this.onBreakpointChange.bind(this);

    // Events
    this.indicators.forEach((indicator) => {
      indicator.addEventListener('click', this.onIndicatorClick);
    });

    this.track.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    if (this.mobileMedia.addEventListener) {
      this.mobileMedia.addEventListener('change', this.onBreakpointChange);
    } else {
      this.mobileMedia.addListener(this.onBreakpointChange);
    }

    this.setActive(this.getActiveIndex());
  }

  disconnectedCallback() {
    if (this.indicators) {
      this.indicators.forEach((indicator) => {
        indicator.removeEventListener('click', this.onIndicatorClick);
      });
    }

    if (this.track) {
      this.track.removeEventListener('scroll', this.onScroll);
    }

    window.removeEventListener('resize', this.onResize);

    if (this.mobileMedia) {
      if (this.mobileMedia.removeEventListener) {
        this.mobileMedia.removeEventListener('change', this.onBreakpointChange);
      } else {
        this.mobileMedia.removeListener(this.onBreakpointChange);
      }
    }

    window.clearTimeout(this.scrollTimeout);
  }

  getSlides() {
    return Array.from(this.track.querySelectorAll('[data-collage-slide]'));
  }

  getActiveIndex() {
    const slides = this.getSlides();
    if (!slides.length) return 0;

    if (!this.mobileMedia.matches) return 0;

    let activeIndex = 0;
    let smallestDistance = Infinity;
    const currentScroll = this.track.scrollLeft;

    slides.forEach((slide, index) => {
      const distance = Math.abs(currentScroll - slide.offsetLeft);
      if (distance < smallestDistance) {
        smallestDistance = distance;
        activeIndex = index;
      }
    });

    return activeIndex;
  }

  scrollToIndex(index) {
    const slides = this.getSlides();
    const slide = slides[index];
    if (!slide) return;

    this.track.scrollTo({
      left: slide.offsetLeft,
      behavior: 'smooth'
    });
  }

  setActive(index) {
    this.indicators.forEach((indicator, indicatorIndex) => {
      const isActive = index === indicatorIndex;

      indicator.classList.toggle('is-active', isActive);

      if (isActive) {
        indicator.setAttribute('aria-current', 'true');
      } else {
        indicator.removeAttribute('aria-current');
      }
    });
  }

  onIndicatorClick(event) {
    if (!this.mobileMedia.matches) return;

    const index = Number(event.currentTarget.dataset.index);
    this.scrollToIndex(index);
    this.setActive(index);
  }

  onScroll() {
    if (!this.mobileMedia.matches) return;

    window.clearTimeout(this.scrollTimeout);

    this.scrollTimeout = window.setTimeout(() => {
      this.setActive(this.getActiveIndex());
    }, 50);
  }

  onResize() {
    this.setActive(this.getActiveIndex());
  }

  onBreakpointChange() {
    if (!this.mobileMedia.matches) {
      this.track.scrollLeft = 0;
      this.setActive(0);
      return;
    }

    this.setActive(this.getActiveIndex());
  }
}


if (!customElements.get('text-image-collage-slider')) {
  customElements.define('text-image-collage-slider', TextImageCollageSlider);
}